import { map } from 'lodash';
import { errorHandler } from 'utils/errorHandler';

const LOAD = 'server-sts/products/LOAD';
const LOAD_SUCCESS = 'server-sts/products/LOAD_SUCCESS';
const LOAD_FAIL = 'server-sts/products/LOAD_FAIL';
const EDIT_START = 'server-sts/products/EDIT_START';
const EDIT_STOP = 'server-sts/products/EDIT_STOP';
const SAVE = 'server-sts/products/SAVE';
const SAVE_SUCCESS = 'server-sts/products/SAVE_SUCCESS';
const SAVE_FAIL = 'server-sts/products/SAVE_FAIL';
const CREATE = 'server-sts/products/CREATE';
const CREATE_SUCCESS = 'server-sts/products/CREATE_SUCCESS';
const CREATE_FAIL = 'server-sts/products/CREATE_FAIL';
const RESET_FORM = 'server-sts/products/RESET_FORM';

const MODIFY_FIELD_ERROR = 'server-sts/products/MODIFY_FIELD_ERROR';


const CHECK_ID_DUPS = 'server-sts/products/CHECK_ID_DUPS';
const CHECK_ID_DUPS_SUCCESS = 'server-sts/products/CHECK_ID_DUPS_SUCCESS';
const CHECK_ID_DUPS_FAIL = 'server-sts/products/CHECK_ID_DUPS_FAIL';

const DELETE = 'server-sts/products/DELETE';
const DELETE_SUCCESS = 'server-sts/products/DELETE_SUCCESS';
const DELETE_FAIL = 'server-sts/products/DELETE_FAIL';

const LOAD_PHONES = 'server-sts/products/LOAD_PHONES';
const LOAD_PHONES_SUCCESS = 'server-sts/products/LOAD_PHONES_SUCCESS';
const LOAD_PHONES_FAIL = 'server-sts/products/LOAD_PHONES_FAIL';

const CLEAR_PRODUCTS = 'server-sts/products/CLEAR_PRODUCTS';

const CANCEL_EDIT = 'server-sts/products/CANCEL_EDIT';

const SEND_SMS = 'server-sts/products/SEND_SMS';
const SEND_SMS_SUCCESS = 'server-sts/products/SEND_SMS_SUCCESS';
const SEND_SMS_FAIL = 'server-sts/products/SEND_SMS_FAIL';

const LOAD_PRODUCT = 'server-sts/products/LOAD_PRODUCT';
const LOAD_PRODUCT_SUCCESS = 'server-sts/products/LOAD_PRODUCT_SUCCESS';
const LOAD_PRODUCT_FAIL = 'server-sts/products/LOAD_PRODUCT_FAIL';

const HANDLE_PIT = 'server-sts/products/HANDLE_PIT';
const HANDLE_PIT_SUCCESS = 'server-sts/products/HANDLE_PIT_SUCCESS';
const HANDLE_PIT_FAIL = 'server-sts/products/HANDLE_PIT_FAIL';

const RESET_SERIAL = 'server-sts/products/RESET_SERIAL';
const RESET_SERIAL_SUCCESS = 'server-sts/products/RESET_SERIAL_SUCCESS';
const RESET_SERIAL_FAIL = 'server-sts/products/RESET_SERIAL_FAIL';


const CLEAR_INTERVAL = 'server-sts/products/CLEAR_INTERVAL';

const GET_USED_MODS = 'server-sts/products/PRODUCTS_PAN_OPEN'
const GET_USED_MODS_SUCCESS = 'server-sts/products/GET_USED_MODS_SUCCESS'
const GET_USED_MODS_FAIL = 'server-sts/products/GET_USED_MODS_FAIL'


const SORT_COUNTS = 'server-sts/products/SORT_COUNTS'
const SORT_COUNTS_SUCCESS = 'server-sts/products/SORT_COUNTS_SUCCESS'
const SORT_COUNTS_FAIL = 'server-sts/products/SORT_COUNTS_FAIL'

const FORCE_ACTIVATION = 'server-sts/products/FORCE_ACTIVATION';
const FORCE_ACTIVATION_SUCCESS = 'server-sts/products/FORCE_ACTIVATION_SUCCESS';
const FORCE_ACTIVATION_FAIL = 'server-sts/products/FORCE_ACTIVATION_FAIL';


const RESET_STATE = 'server-sts/products/RESET_STATE';
const RESET_STATE_SUCCESS = 'server-sts/products/RESET_STATE_SUCCESS';
const RESET_STATE_FAIL = 'server-sts/products/RESET_STATE_FAIL';

const BEGIN_INTERVAL = 'server-sts/products/BEGIN_INTERVAL';
const END_INTERVAL = 'server-sts/products/END_INTERVAL';
const BEGIN_INTERVAL_SPECIAL = 'server-sts/products/BEGIN_INTERVAL_SPECIAL';
const END_INTERVAL_SPECIAL = 'server-sts/products/END_INTERVAL_SPECIAL';


const GET_SITE_STATE = 'server-sts/products/GET_SITE_STATE';
const GET_SITE_STATE_SUCCESS = 'server-sts/products/GET_SITE_STATE_SUCCESS';
const GET_SITE_STATE_FAIL = 'server-sts/products/GET_SITE_STATE_FAIL';
const SITE_STATE_WS_UPDATE = 'server-sts/products/SITE_STATE_WS_UPDATE';

const MODIFY_GSM = 'server-sts/products/MODIFY_GSM';
const MODIFY_GSM_SUCCESS = 'server-sts/products/MODIFY_GSM_SUCCESS';
const MODIFY_GSM_FAIL = 'server-sts/products/MODIFY_GSM_FAIL';

const ADMIN_CHANGE_GSM = 'server-sts/products/ADMIN_CHANGE_GSM';
const ADMIN_CHANGE_GSM_SUCCESS = 'server-sts/products/ADMIN_CHANGE_GSM_SUCCESS';
const ADMIN_CHANGE_GSM_FAIL = 'server-sts/products/ADMIN_CHANGE_GSM_FAIL';

const TEST_LIFT_SESSION = 'server-sts/products/TEST_LIFT_SESSION';
const TEST_LIFT_SESSION_SUCCESS = 'server-sts/products/TEST_LIFT_SESSION_SUCCESS';
const TEST_LIFT_SESSION_FAIL = 'server-sts/products/TEST_LIFT_SESSION_FAIL';
const RESET_TEST_LIFT_SESSION = 'server-sts/products/RESET_TEST_LIFT_SESSION';
let testLiftRequestSequence = 0;

const MODIFY_IDPTU = 'server-sts/products/MODIFY_IDPTU';
const MODIFY_IDPTU_SUCCESS = 'server-sts/products/MODIFY_IDPTU_SUCCESS';
const MODIFY_IDPTU_FAIL = 'server-sts/products/MODIFY_IDPTU_FAIL';

const PRODUCTS_PAN_OPEN = 'server-sts/products/PRODUCTS_PAN_OPEN';
const PRODUCTS_LIST_PAN_OPEN = 'server-sts/products/PRODUCTS_LIST_PAN_OPEN';

const EXPAND_TABS = 'server-sts/products/EXPAND_TABS';


const ACTIVATE_CYCLICAL = 'server-sts/products/ACTIVATE_CYCLICAL';
const ACTIVATE_CYCLICAL_FAIL = 'server-sts/products/ACTIVATE_CYCLICAL_FAIL';
const ACTIVATE_CYCLICAL_SUCCESS = 'server-sts/products/ACTIVATE_CYCLICAL_SUCCESS';


const REMOVE_CYCLICAL = 'server-sts/products/REMOVE_CYCLICAL';
const REMOVE_CYCLICAL_FAIL = 'server-sts/products/REMOVE_CYCLICAL_FAIL';
const REMOVE_CYCLICAL_SUCCESS = 'server-sts/products/REMOVE_CYCLICAL_SUCCESS';

const EXPORT_PRODUCTS = 'server-sts/products/EXPORT_PRODUCTS';
const EXPORT_PRODUCTS_FAIL = 'server-sts/products/EXPORT_PRODUCTS_FAIL';
const EXPORT_PRODUCTS_SUCCESS = 'server-sts/products/EXPORT_PRODUCTS_SUCCESS';

const IMPORT_PRODUCTS = 'server-sts/products/IMPORT_PRODUCTS';
const IMPORT_PRODUCTS_FAIL = 'server-sts/products/IMPORT_PRODUCTS_FAIL';
const IMPORT_PRODUCTS_SUCCESS = 'server-sts/products/IMPORT_PRODUCTS_SUCCESS';

const INIT_PRODUCT_IMPORT = 'server-sts/products/INIT_PRODUCT_IMPORT';

import { analyseState } from 'utils/analyseState';



const initialState = {
  loaded: false,
  loading: false,
  created: false,
  productCreatedError: false,
  editing: {},
  saveError: false,
  success: false,
  currentPage: 1,
  error: false,
  currentProducts: [],
  success: false,
  smsActions: {},
  productsPanOpen: true,
  phones: [],
  pit_loading: false,
  pit_error: false,
  pit_success: false,
  used_mods: [],
  get_used_mods_loading: false,
  get_used_mods_success: false,
  get_used_mods_fail: false,
  from: false,
  id_dup: false,
  check_id_dups_loading: false,
  level_counts_loading: false,
  levels_counts: null,
  forceActivationSuccess: false,
  forceActivationError: false,
  data: [],
  product: false,
  idptuError: false,
  phoneError: false,
  mcpCalled: false,
  modifyGSMLoading: false,
  modifyGSMError: false,
  modifyGSMSuccess: false,
  adminChangeGSMLoading: false,
  adminChangeGSMError: false,
  adminChangeGSMSuccess: false,
  testLiftSessionLoading: false,
  testLiftSessionError: false,
  testLiftSession: false,
  testLiftSessionRequestId: null,
  resetSerialError: false,
  resetSerialSuccess: false,
  resetSerialLoading: false,
  from: false,
  site_state: null,
  intervalAfterReload: false,
  productsPanOpen: true,
  productsListPanOpen: false,
  sort_counts_begin_date: null,
  sort_counts_end_date: null,
  extra_tabs: true,
  id_dup_text: false,
  productExportFail: false,
  productExportSuccess: false,
  importingProducts: false,
  productImportFail: false,
  productImportSuccess: false,
  selectedTab: 1,
  basicTabs: true,

  pagination: { // initial pagination settings
    page: 1,
    perPage: 10
  },

  genBilanLoading:false,
  genBilanSuccess:false,
  genBilanError:false,

};

export default function reducer(state = initialState, action = {}) {

  //
  switch (action.type) {


    case 'STORE_SELECTED_TAB':

      return {
        ...state,
        selectedTab: action.key
      };




    case IMPORT_PRODUCTS:
      return {
        ...state,
        importingProducts: true,
        productImportFail: false,
        productImportSuccess: false,

      };

    case IMPORT_PRODUCTS_SUCCESS:
      return {
        ...state,
        productImportSuccess: true,
        importingProducts: false,


      };

    case IMPORT_PRODUCTS_FAIL:
      return {
        ...state,
        productImportFail: true,
        importingProducts: false,

      };


    case INIT_PRODUCT_IMPORT:
      return {
        ...state,
        productImportFail: false,
        productImportSuccess: false,
        importingProducts: false,

      };



    case EXPORT_PRODUCTS:
      return {
        ...state,
        productExportFail: false,
        productExportSuccess: false,

      };

    case EXPORT_PRODUCTS_SUCCESS:
      return {
        ...state,
        productExportSuccess: true,


      };

    case EXPORT_PRODUCTS_FAIL:
      return {
        ...state,
        productExportFail: true,

      };





    case PRODUCTS_PAN_OPEN:
      return {
        ...state,
        productsPanOpen: !state.productsPanOpen,
      };


    case PRODUCTS_LIST_PAN_OPEN:
      return {
        ...state,
        productsListPanOpen: !state.productsListPanOpen,
      };


    case BEGIN_INTERVAL_SPECIAL:
      var smsActions = {

        from: action.from,
        [action.id]: {
          [action.actionType]: {
            intervalLaunched: true,
            interval: action.interval,
            smsLoaded: true,
            intervalFinished: false,
            error: false,
            smsSent: true
          }
        }
      }



    case 'STORE_PAGINATION':


      return {
        ...state,
        pagination: action.pagination,
      };


    case 'STORE_QUERY':


      return {
        ...state,
        query: action.query,
      };

    case 'STORE_SORTING':


      return {
        ...state,
        sortingColumns: action.sortingColumns
      };


    case END_INTERVAL_SPECIAL:

      return {
        ...state,
        mcpCalled: false,
        smsActions: {
          ...state.smsActions,
          [action.id]: {
            ...state.smsActions[action.id],
            [action.actionType]: {
              ...state.smsActions[action.id][action.actionType],
              intervalLaunched: false,
              intervalFinished: true,
              smsLoaded: false,
              success: true,

            },
            lastState: state.smsActions[action.id][action.actionType].state
          }
        }
      };


    case PRODUCTS_PAN_OPEN:
      return {
        ...state,
        productsPanOpen: !state.productsPanOpen,
      };

    case LOAD:
      return {
        ...state,
        loading: true
      };

    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.result,
        currentPage: action.result.currentPage,
        productsNb: action.result.productsNb,
        pages: action.result.pages,
        error: false,

      };

    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: [],
        error: errorHandler(action.error.code)
      };


    case FORCE_ACTIVATION:
      return state;
    case FORCE_ACTIVATION_SUCCESS:
      return {
        ...state,
        product: action.result,
        forceActivationSuccess: true,
        forceActivationError: false
      };
    case FORCE_ACTIVATION_FAIL:
      return {
        ...state,
        error: errorHandler(action.error.code),
        success: false,
        forceActivationSuccess: false,
        forceActivationError: true
      };

    case LOAD_PRODUCT:
      return {
        ...state,
        loading: true
      };

    case LOAD_PRODUCT_SUCCESS:

      return {
        ...state,
        loading: false,
        loaded: false,
        error: null,
        product: action.result,
        used_mods: action.result.used_mods,
        levels_counts: action.result.levels_counts,
        /*smsActions:{
        	...state.smsActions,
        	[action.result.s_id]: {
        	}
        }*/
      };

    case LOAD_PRODUCT_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
        product: false
      };


    case LOAD_PHONES:
      return {
        ...state,
        loading: true
      };

    case LOAD_PHONES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        phones: action.result
      };

    case LOAD_PHONES_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case EDIT_START:
      return {
        ...state,
        editing: {
          ...state.editing,
          [action.id]: true
        }
      };


    case RESET_STATE:
      return state;
    case RESET_STATE_SUCCESS:
      return {
        ...state,
        product: action.result,
        resetStateSuccess: true,
        resetStateError: false
      };
    case RESET_STATE_FAIL:
      return {
        ...state,
        error: errorHandler(action.error.code),
        resetStateSuccess: false,
        resetStateError: true
      };

    case CANCEL_EDIT:
      return {
        ...state,
        editing: {},
      };

    case EDIT_STOP:
      return {
        ...state,
        editing: {
          ...state.editing,
          [action.id]: false
        },
        success: false,
        saveError: false
      };

    case CREATE:
      return {
        ...state,
        loading: true,
        created: false,
        error: false,
        success: false,
      };

    case CREATE_SUCCESS:
      return {
        ...state,
        data: action.result,
        currentPage: action.result.products.currentPage,
        productsNb: action.result.products.productsNb,
        pages: action.result.products.pages,
        created: true,
        success: true,
        loading: false,
        error: false,
        created: true,
        insertId: action.result.insertId
      };



    case RESET_SERIAL:
      return {
        ...state,
        loading: true
      };

    case RESET_SERIAL_SUCCESS:

      return {
        ...state,
        loading: false,
        resetSerialError: false,
      };

    case RESET_SERIAL_FAIL:
      return {
        ...state,
        created: false,
        loading: false,
        resetSerialError: action.error,
      };

    case CREATE_FAIL:
      return {
        ...state,
        success: false,
        created: false,
        loading: false,
        error: errorHandler(action.error.code),
      };

    case DELETE:
      return {
        ...state,
        loading: true
      };

    case DELETE_SUCCESS:


      return {
        ...state,
				/*data: action.result,
        currentPage:1,
        productsNb:action.result.length, 
        pages:Math.ceil(action.result.length/10), */
        loading: false,
        productCreatedError: false,
      };

    case DELETE_FAIL:
      return {
        ...state,
        created: false,
        loading: false,
        error:action.error,
      };

    case RESET_FORM:
      return {
        ...state,
        loading: false,
        success: false,
        error: false,
        id_dup: false,
        created: false,
        forceActivationSuccess: false,
        forceActivationError: false,
        idptuError: false,
        phoneError: false,
        mcpCalled: false,
        modifyGSMLoading: false,
        modifyGSMError: false,
        modifyGSMSuccess: false,
        resetSerialError: false,
        resetSerialSuccess: false,
        resetSerialLoading: false,
        testLiftSessionLoading: false,
        testLiftSessionError: false,
        testLiftSession: false,
        testLiftSessionRequestId: null,
        from: false,
        site_state: null,
        intervalAfterReload: false,
        smsActions: {},
        extra_tabs: false,
        basicTabs: true,

      };


    case MODIFY_FIELD_ERROR:


      return {
        ...state,

        smsActions: {
          ...state.smsActions,
          [action.id]: {
            ...state.smsActions[action.id],
            [action.actionType]: {
              ...state.smsActions[action.id][action.actionType],
              error: action.error,
            }
          }
        }
      };

    case CLEAR_PRODUCTS:
      return {
        ...state,
        data: [],
        loaded: false,
        created: false
      };

    case SEND_SMS:

      var requestSameState = null

      if (action.from == 'ftpPanel') {

        if (((action.actionType == 'asts1' || action.actionType == 'aspr1') && action.isActivated)
          ||
          ((action.actionType == 'asts0' || action.actionType == 'aspr0') && !action.isActivated)

        ) {
          requestSameState = true
        } else {
          requestSameState = false
        }

      }



      return {
        ...state,
        from: action.from,
        smsActions: {
          ...state.smsActions,
          [action.id]: {
            ...state.smsActions[action.id],
            [action.actionType]: {
              smsLoaded: false,
              smsLoading: true,
              type: action.actionType,
              label: action.actionLabel,
              date: new Date().getTime(),
              initialActionState: action.initialActionState,
              success: false,
              intervalLaunched: false,
              intervalFinished: false,
              error: false,
              from: action.from,
              requestSameState,
              smsSent: false,
              requested: false
            }
          }
        }
      };

    case SEND_SMS_SUCCESS:


      return {
        ...state,
        mcpCalled: true,
        smsActions: {
          ...state.smsActions,
          [action.id]: {
            ...state.smsActions[action.id],
            [action.actionType]: {
              ...state.smsActions[action.id][action.actionType],
              smsLoaded: true,
              smsLoading: false,
              intervalLaunched: true,
              smsSent: true
            }
          }
        }
      };

    case SEND_SMS_FAIL:
      return {
        ...state,
        smsActions: {
          ...state.smsActions,
          [action.id]: {
            ...state.smsActions[action.id],
            [action.actionType]: {
              ...state.smsActions[action.id][action.actionType],
              smsLoaded: false,
              smsLoading: false,
              error: action.error,
            }
          }
        }
      };

    case SAVE:
      return {
        ...state,
        loading: true,
        success: false,
        error: false
      }
    case SAVE_SUCCESS:
      return {
        ...state,
        success: true,
        error: false,
        data: action.result,
        loading: false

      };
    case SAVE_FAIL:



      return {
        ...state,
        error: errorHandler(action.error.code),
        success: false
      };


    case HANDLE_PIT:
      return {
        ...state,
        pit_loading: true,
        pit_error: false,
      }; // 'saving' flag handled by redux-form
    case HANDLE_PIT_SUCCESS:

      return {
        ...state,
        pit_success: true,
        pit_error: false,
        product: action.result.load,
        pit_loading: false,
        loaded: false,
        pit_id: action.result.pit_id

      };
    case HANDLE_PIT_FAIL:
      return {
        ...state,
        pit_error: errorHandler(action.error.code),
        pit_success: false,
        pit_loading: false
      };


    case GET_USED_MODS:
      return {
        ...state,
        get_used_mods_loading: true,
      }; // 'saving' flag handled by redux-form
    case GET_USED_MODS_SUCCESS:
      return {
        ...state,
        used_mods: action.result,
        get_used_mods_success: true
      };
    case GET_USED_MODS_FAIL:
      return {
        ...state,
        get_used_mods_fail: true
      };



    case CHECK_ID_DUPS:
      return {
        ...state,
        check_id_dups_loading: true,
        id_dup_text: false,

      }; // 'saving' flag handled by redux-form
    case CHECK_ID_DUPS_SUCCESS:
      return {
        ...state,
        id_dup: false,
        id_dup_text: false,
        check_id_dups_loading: false,
      };
    case CHECK_ID_DUPS_FAIL:
      return {
        ...state,
        id_dup: true,
        id_dup_text: action.error,
        check_id_dups_loading: false,
      };


    case SORT_COUNTS:
      return {
        ...state,
        sort_counts_loading: true,
        sort_counts_begin_date: action.begin_date,
        sort_counts_end_date: action.end_date

      }; // 'saving' flag handled by redux-form
    case SORT_COUNTS_SUCCESS:
      return {
        ...state,
        sort_counts_loading: false,
        levels_counts: action.result
      };
    case SORT_COUNTS_FAIL:
      return {
        ...state,
        sort_counts_loading: false,
      };


    case GET_SITE_STATE:



      if (action.id in state.smsActions == false) {
        return state
      }
      return {
        ...state,
        loading_get_site_state: false,

        smsActions: {
          ...state.smsActions,
          [action.id]: {
            ...state.smsActions[action.id],
            [action.actionType]: {
              ...state.smsActions[action.id][action.actionType],

            }
          }
        }

      };


    case GET_SITE_STATE_SUCCESS:

      var rstate = analyseState(action.result.etat)

      // Après F5, smsActions peut être vide - on met quand même à jour site_state
      if (action.id in state.smsActions == false) {
        return {
          ...state,
          loading_get_site_state: false,
          site_state: action.result.etat,
        }
      }

      var rObject = {
        ...state,
        loading_get_site_state: false,
        site_state: action.result.etat,

        smsActions: {
          ...state.smsActions,
          [action.id]: {
            ...state.smsActions[action.id],
            [action.actionType]: {
              ...state.smsActions[action.id][action.actionType],

            }
          }
        }
      }

      if (rstate[action.actionType].state == 2) {
        rObject.smsActions[action.id][action.actionType]['smsSent'] = true
      } else if (rstate[action.actionType].state == 1) {
        rObject.smsActions[action.id][action.actionType]['requested'] = true
      }



      return rObject




    case GET_SITE_STATE_FAIL:


      return {
        ...state,
        loading_get_site_state: false,
      };

    // Mise à jour via WebSocket - notification instantanée du MCP
    case SITE_STATE_WS_UPDATE:
      // Désactiver mcpCalled et intervalLaunched si une action est terminée (state >= 3)
      // action.state est un entier (ex: 27), on le décompose en octal comme analyseState
      var wsMcpDone = false;
      var wsSchema = ['asts1', 'asts0', 'aspr1', 'aspr0'];
      var wsFinishedActions = {};
      try {
        var wsVal = parseInt(action.state);
        if (wsVal > 0) {
          var binMask = "000";
          var binString = wsVal.toString(2);
          var octalList = (binMask.substring(0, 3 - (binString.length % 3)) + binString).match(/.{1,3}/g).reverse();
          for (var oi = 0; oi < octalList.length && oi < 4; oi++) {
            var actionState = parseInt(octalList[oi], 2);
            if (actionState >= 3) {
              wsMcpDone = true;
              wsFinishedActions[wsSchema[oi]] = true;
            }
          }
        }
      } catch(e) {}
      // Mettre à jour smsActions pour les actions terminées (intervalLaunched=false, intervalFinished=true)
      var wsUpdatedSmsActions = { ...state.smsActions };
      if (wsMcpDone && action.siteId && state.smsActions[action.siteId]) {
        wsUpdatedSmsActions = {
          ...wsUpdatedSmsActions,
          [action.siteId]: { ...wsUpdatedSmsActions[action.siteId] }
        };
        Object.keys(wsFinishedActions).forEach(function(aType) {
          if (wsUpdatedSmsActions[action.siteId][aType]) {
            wsUpdatedSmsActions[action.siteId][aType] = {
              ...wsUpdatedSmsActions[action.siteId][aType],
              intervalLaunched: false,
              intervalFinished: true
            };
          }
        });
      }
      return {
        ...state,
        site_state: action.state,
        ws_site_id: action.siteId,
        mcpCalled: wsMcpDone ? false : state.mcpCalled,
        smsActions: wsUpdatedSmsActions,
      };

    case BEGIN_INTERVAL:
      var label;
      if (action.actionType == 'asts1') {
        label = 'Activation du FTP AMPHITECH'
      } else if (action.actionType == 'aspr1') {
        label = 'Activation du FTP PRESTATAIRE'
      } else if (action.actionType == 'asts0') {
        label = 'Désactivation du FTP AMPHITECH'
      } else if (action.actionType == 'aspr0') {
        label = 'Désactivation du FTP PRESTATAIRE'
      }



      return {
        ...state,
        mcpCalled: true,
        from: action.from,
        smsActions: {
          ...state.smsActions,
          [action.id]: {
            ...state.smsActions[action.id],
            [action.actionType]: {
              ...state.smsActions[action.id][action.actionType],
              intervalLaunched: true,
              interval: action.interval,
              smsSent: false,
              requested: false,
              type: action.actionType,
              label
            }
          }
        }
      };

    case END_INTERVAL:

      return {
        ...state,
        mcpCalled: false,
        smsActions: {
          ...state.smsActions,
          [action.id]: {
            ...state.smsActions[action.id],
            [action.actionType]: {
              ...state.smsActions[action.id][action.actionType],
              intervalLaunched: false,
              intervalFinished: true,
              smsLoaded: false,
              success: true,
              smsSent: false,
              requested: false
            }
          }
        }
      };


    case MODIFY_GSM:
      return {
        ...state,
        modifyGSMLoading: true
      };

    case MODIFY_GSM_SUCCESS:
      return {
        ...state,
        modifyGSMError: false,
        modifyGSMSuccess: true,
        modifyGSMLoading: false
      };

    case MODIFY_GSM_FAIL:

      return {
        ...state,
        modifyGSMError: action.error,
        modifyGSMSuccess: false,
        modifyGSMLoading: false
      };

    case ADMIN_CHANGE_GSM:
      return {
        ...state,
        adminChangeGSMLoading: true,
        adminChangeGSMError: false,
        adminChangeGSMSuccess: false
      };

    case ADMIN_CHANGE_GSM_SUCCESS:
      return {
        ...state,
        adminChangeGSMError: false,
        adminChangeGSMSuccess: true,
        adminChangeGSMLoading: false
      };

    case ADMIN_CHANGE_GSM_FAIL:
      return {
        ...state,
        adminChangeGSMError: action.error,
        adminChangeGSMSuccess: false,
        adminChangeGSMLoading: false
      };

    case RESET_TEST_LIFT_SESSION:
      return {
        ...state,
        testLiftSessionLoading: false,
        testLiftSessionError: false,
        testLiftSession: false,
        testLiftSessionRequestId: null
      };

    case TEST_LIFT_SESSION:
      return {
        ...state,
        testLiftSessionLoading: true,
        testLiftSessionError: false,
        testLiftSession: false,
        testLiftSessionRequestId: action.requestId
      };

    case TEST_LIFT_SESSION_SUCCESS:
      if (action.requestId !== state.testLiftSessionRequestId) return state;
      return {
        ...state,
        testLiftSessionError: false,
        testLiftSession: action.result,
        testLiftSessionLoading: false,
        testLiftSessionRequestId: null
      };

    case TEST_LIFT_SESSION_FAIL:
      if (action.requestId !== state.testLiftSessionRequestId) return state;
      return {
        ...state,
        testLiftSessionError: action.error,
        testLiftSession: false,
        testLiftSessionLoading: false,
        testLiftSessionRequestId: null
      };

    case MODIFY_IDPTU:
      return {
        ...state,
        modifyIDPTULoading: true
      };

    case MODIFY_IDPTU_SUCCESS:
      return {
        ...state,
        modifyIDPTUError: false,
        modifyIDPTUSuccess: true,
        modifyIDPTULoading: false
      };

    case MODIFY_IDPTU_FAIL:

      return {
        ...state,
        modifyIDPTUError: action.error,
        modifyIDPTUSuccess: false,
        modifyIDPTULoading: false
      };


    case EXPAND_TABS:



      return {
        ...state,
        extra_tabs: action.open ? true : !state.extra_tabs,
        selectedTab: action.key
      }


    case 'EXPAND_BASIC_TABS':



      return {
        ...state,
        basicTabs: action.open ? true : !state.basicTabs,
        selectedTab: action.key
      }


    case ACTIVATE_CYCLICAL:
      return {
        ...state,
      }

    case ACTIVATE_CYCLICAL_FAIL:
      return {
        ...state,
      }

    case ACTIVATE_CYCLICAL_SUCCESS:
      return {
        ...state,
      }

    case REMOVE_CYCLICAL:
      return {
        ...state,
      }

    case 'GEN_BILAN':
      return {
        ...state,
        genBilanLoading: true
      }

    case 'GEN_BILAN_SUCCESS':
      return {
        ...state,
        genBilanError: false,
        genBilanSuccess: true,
        genBilanLoading: false
      };

    case 'GEN_BILAN_FAIL':

      return {
        ...state,
        genBilanError: true,
        genBilanSuccess: false,
        genBilanLoading: false
      };

    default:
      return state;
  }
}



export function initProductImport() {

  return { type: INIT_PRODUCT_IMPORT };
}


export function isLoaded(globalState) {
  return globalState.products && globalState.products.loaded;
}


export function createProduct(values, fields, params) {

  return {
    types: [CREATE, CREATE_SUCCESS, CREATE_FAIL],
    promise: (product) => product.post('/product/create', {
      data: {
        values,
        fields,
        params
      }
    })
  };
}

export function load(page, params) {

  var data = params ? { page, params } : { page };
  return {
    promise: (product) => product.post('/product/load', { data: data }),
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],

  };
}


export function loadProduct(productID, params, statDates) {


  //var data = params ? { productID, params, ...statDates } : { productID, ...statDates };
  return {
    promise: (product) => product.post('/product/loadProduct', { data: { productID, params, ...statDates } }),
    types: [LOAD_PRODUCT, LOAD_PRODUCT_SUCCESS, LOAD_PRODUCT_FAIL],
  };
}



export function checkIdDups(params) {

  return {
    promise: (product) => product.post('/product/checkIdDups', { data: { ...params } }),
    types: [CHECK_ID_DUPS, CHECK_ID_DUPS_SUCCESS, CHECK_ID_DUPS_FAIL],
  };
}



export function save(values, fields, params, pristineValues, is_pit, is_master, pit_id) {

	/*
	var params = params ? {id:params.id} : {};
	if(values.localisation_adresse != null ) {
		if( typeof values.localisation_adresse === 'object') {
			values.localisation_adresse = values.localisation_adresse.label;
		}
	}*/

  return {
    types: [SAVE, SAVE_SUCCESS, SAVE_FAIL],
    id: values.id,
    promise: (product) => product.post('/product/update', {
      data: { values, fields, params, pristineValues, is_pit, is_master, pit_id }
    })
  };
}


/*export function sendSMS(site, payload, params, type, state, actionLabel, from, isActivated=null) {

  return {
    types: [SEND_SMS, SEND_SMS_SUCCESS, SEND_SMS_FAIL],
    id: site.id,
    from,
    promise: (product) => product.post('/fiche/sendSMS', {
      data: {site, payload, params},
    }), actionType:type, initialActionState:state, actionLabel, isActivated
  };
}*/

export function sendSMS(site, payload, params, type, state, actionLabel, from, isActivated) {
  return {
    types: [SEND_SMS, SEND_SMS_SUCCESS, SEND_SMS_FAIL],
    id: site.id,
    from,
    promise: (fiche) => fiche.post('/fiche/sendSMS', {
      data: { fiche: site, payload, params },
    }), actionType: type, initialActionState: state, actionLabel

  };
}


export function deleteProduct(fiche, params) {
  return {
    types: [DELETE, DELETE_SUCCESS, DELETE_FAIL],
    promise: (product) => product.post('/product/deleteProduct', {
      data: { fiche, params }
    })
  };
}

export function beginInterval(actionType, interval, from = false, id) {
  return { type: BEGIN_INTERVAL, actionType, interval, from, id };
}

export function endInterval(actionType, id) {
  return { type: END_INTERVAL, actionType, id };
}



export function beginIntervalSpecial(actionType, interval, from = false, id) {
  return { type: BEGIN_INTERVAL_SPECIAL, actionType, interval, from, id };
}



/*
export function restrictIDPTU(productObj, params) {

  return {
    types: [RESTRICT_IDPTU, RESTRICT_IDPTU_SUCCESS, RESTRICT_IDPTU_FAIL],
    id: productObj.id,
    promise: (product) => product.post('/product/sendSMS', {
      data: {product:productObj, params},
    })
  };
}
*/

export function loadPhones(params) {

  return {
    types: [LOAD_PHONES, LOAD_PHONES_SUCCESS, LOAD_PHONES_FAIL],
    promise: (product) => product.post('/product/loadPhones', {
      data: { params }
    })
  };

}


export function activateCyclical(p_id, params) {

  return {
    types: [ACTIVATE_CYCLICAL, ACTIVATE_CYCLICAL_SUCCESS, ACTIVATE_CYCLICAL_FAIL],
    promise: (product) => product.post('/product/activateCyclical', {
      data: { p_id, params }
    })
  };

}


export function removeCyclical(p_id, params) {

  return {
    types: [REMOVE_CYCLICAL, REMOVE_CYCLICAL_SUCCESS, REMOVE_CYCLICAL_FAIL],
    promise: (product) => product.post('/product/removeCyclical', {
      data: { p_id, params }
    })
  };

}


export function checkFtpActivation() {

}


export function clearProducts() {

  return { type: CLEAR_PRODUCTS };
}

export function resetFormCs() {
  return { type: RESET_FORM };
}

export function editStart(id) {
  return { type: EDIT_START, id };
}

export function editStop(id) {
  return { type: EDIT_STOP, id };
}

export function cancelEdit() {
  return { type: CANCEL_EDIT };
}

export function resetForm() {
  return { type: RESET_FORM };
}


export function handlePit(params, values, fields, remove) {
  return {
    types: [HANDLE_PIT, HANDLE_PIT_SUCCESS, HANDLE_PIT_FAIL],
    promise: (product) => product.post('/product/handlePit', {
      data: { values, remove, params, fields }
    })
  };
}

export function resetSerial(params, id, serial, identification_ID) {
  return {
    types: [RESET_SERIAL, RESET_SERIAL_SUCCESS, RESET_SERIAL_FAIL],
    promise: (product) => product.post('/product/resetSerial', {
      data: { params, siteID: id, serial, identification_ID }
    })
  };
}


export function getUsedMods(obj) {

  return {
    types: [GET_USED_MODS, GET_USED_MODS_SUCCESS, GET_USED_MODS_FAIL],
    promise: (product) => product.post('/product/getUsedMods', {
      data: obj
    })
  };

}


export function sortCounts(begin_date, end_date, params) {

  return {
    types: [SORT_COUNTS, SORT_COUNTS_SUCCESS, SORT_COUNTS_FAIL],
    promise: (product) => product.post('/product/sortCounts', {
      data: { begin_date, end_date, params }
    }), begin_date, end_date
  };

}


export function forceActivation(siteID, productID, params) {

  return {
    types: [FORCE_ACTIVATION, FORCE_ACTIVATION_SUCCESS, FORCE_ACTIVATION_FAIL],
    promise: (fiche) => fiche.post('/product/forceActivation', {
      data: { siteID, params, productID },
    })
  };
}

export function resetState(siteID, productID, params) {

  return {
    types: [RESET_STATE, RESET_STATE_SUCCESS, RESET_STATE_FAIL],
    promise: (fiche) => fiche.post('/product/resetState', {
      data: { siteID, params, productID },
    })
  };
}



export function getSiteState(ficheID, params, actionType) {
  var data = params ? { ficheID, params } : { ficheID };
  return {
    id: ficheID,
    actionType,
    promise: (fiche) => fiche.post('/fiche/loadFiche', { data: data }),
    types: [GET_SITE_STATE, GET_SITE_STATE_SUCCESS, GET_SITE_STATE_FAIL],

  };
}

// Action pour recevoir les mises à jour WebSocket
export function siteStateWsUpdate(siteId, state) {
  return {
    type: SITE_STATE_WS_UPDATE,
    siteId,
    state,
  };
}


export function modifyGSM(siteId, pid, gsm, pristineTid, user, params, pristineSerial, identificationType) {
  return {
    types: [MODIFY_GSM, MODIFY_GSM_SUCCESS, MODIFY_GSM_FAIL],
    promise: (fiche) => fiche.post('/fiche/modifyGSM', {
      data: { siteId, gsm, user, params, pristineTid, pid, pristineSerial, identificationType },
    })
  };
}



export function modifyIDPTU(siteId, pid, IDPTU, pristineIDPTU, user, params) {

  return {
    types: [MODIFY_IDPTU, MODIFY_IDPTU_SUCCESS, MODIFY_IDPTU_FAIL],
    promise: (fiche) => fiche.post('/fiche/modifyIDPTU', {
      data: { siteId, IDPTU, user, params, pristineIDPTU, pid },
    })
  };
}

export function adminChangeGSM(siteId, newGSM, params) {
  return {
    types: [ADMIN_CHANGE_GSM, ADMIN_CHANGE_GSM_SUCCESS, ADMIN_CHANGE_GSM_FAIL],
    promise: (fiche) => fiche.post('/fiche/adminChangeGSM', {
      data: { siteId, newGSM, params },
    })
  };
}

export function resetTestLiftSession() {
  return { type: RESET_TEST_LIFT_SESSION };
}

export function testLiftSession(productID, params) {
  return {
    requestId: ++testLiftRequestSequence,
    types: [TEST_LIFT_SESSION, TEST_LIFT_SESSION_SUCCESS, TEST_LIFT_SESSION_FAIL],
    promise: (product) => product.post('/product/testLiftSession', {
      data: { productID, params },
    })
  };
}


export function exportProducts(params) {
  return {
    types: [EXPORT_PRODUCTS, EXPORT_PRODUCTS_SUCCESS, EXPORT_PRODUCTS_FAIL],
    promise: (fiche) => fiche.post('/importExport/exportProducts', {
      data: { params },
    })
  };
}


export function importProducts(params, sitesToCreate, sitesToUpdate, productsWithoutPhoneToCreate, cid) {
  return {
    types: [IMPORT_PRODUCTS, IMPORT_PRODUCTS_SUCCESS, IMPORT_PRODUCTS_FAIL],
    promise: (fiche) => fiche.post('/importExport/importProducts', {
      data: { params, sitesToCreate, sitesToUpdate, productsWithoutPhoneToCreate, cid },
    })
  };
}


export function editObjectives(params, objectives) {
  return {
    types: ['EDIT_OBJECTIVES', 'EDIT_OBJECTIVES_SUCCESS', 'EDIT_OBJECTIVES_FAIL'],
    promise: (fiche) => fiche.post('/fiche/editObjectives', {
      data: { params, objectives },
    })
  };
}


export function storeSelectedTab(key) {
  return { type: 'STORE_SELECTED_TAB', key };
}



export function expandBasicTabs(key, open = false) {
  return { type: 'EXPAND_BASIC_TABS', key, open };
}

export function expandTabs(key, open = false) {
  return { type: EXPAND_TABS, key, open };
}


export function openProductsPan() {
  return { type: PRODUCTS_PAN_OPEN };
}


export function modifyFieldError(field, error, id, actionType) {
  return { type: MODIFY_FIELD_ERROR, error, id, actionType };
}


export function storeQuery(query) {
  return { type: 'STORE_QUERY', query };
}


export function storeSorting(sortingColumns) {
  return { type: 'STORE_SORTING', sortingColumns };
}

export function storePagination(pagination) {
  return { type: 'STORE_PAGINATION', pagination };
}




export function generationsBilans(client) {

  return {
    types: ['GEN_BILAN', 'GEN_BILAN_SUCCESS', 'GEN_BILAN_FAIL'],
    promise: (product) => product.post('/product/generationsBilans', {
      data: {
        client
      }
    })
  };
}